import React, { FC } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface GenInputLabelProps {
  error?: boolean;
  required?: boolean;
  fullwidth?: boolean;
  children: React.ReactNode;
}

export const GenInputLabel: FC<GenInputLabelProps> = (props) => {
  const { error, required, children, fullwidth } = props;
  return (
    <Box display="inline-flex" width={fullwidth ? "100%" : "auto"}>
      <Typography variant="body2" color={error ? "red" : "secondary"}>
        {children}
      </Typography>
      {required && (
        <Typography variant="body2" color="red">
          *
        </Typography>
      )}
    </Box>
  );
};

export default GenInputLabel;
